<div class="orders py-3 pagination-order">
  <header
    class="orders-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <h1>Invoice Review</h1>
    <div class="prospects-panel d-flex justify-content-between ms-2 me-auto">
      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <p-radioButton
          id="Open"
          type="radio"
          class="me-2"
          name="radio"
          [ariaChecked]="selectedRadioButton === 'Open' ? true : false"
          (onClick)="getOrderOnChange($event)" />

        <span class="link">Open</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <p-radioButton
          id="Approved"
          type="radio"
          class="me-2"
          name="radio"
          [ariaChecked]="selectedRadioButton === 'Approve' ? true : false"
          (onClick)="getOrderOnChange($event)" />

        <span class="link">Approved</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <p-radioButton
          id="Wrong"
          type="radio"
          class="me-2"
          name="radio"
          [ariaChecked]="selectedRadioButton === 'Wrong' ? true : false"
          (onClick)="getOrderOnChange($event)" />

        <span class="link">Wrong</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <p-radioButton
          id="Invoiced"
          type="radio"
          class="me-2"
          name="radio"
          [ariaChecked]="selectedRadioButton === 'Invoiced' ? true : false"
          (onClick)="getOrderOnChange($event)" />

        <span class="link">Invoiced</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <p-radioButton
          id="Canceled"
          type="radio"
          class="me-2"
          name="radio"
          [ariaChecked]="selectedRadioButton === 'Canceled' ? true : false"
          (onClick)="getOrderOnChange($event)" />

        <span class="link">Canceled</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <p-radioButton
          id="All"
          type="radio"
          class="me-2"
          name="radio"
          [ariaChecked]="selectedRadioButton === 'All' ? true : false"
          (onClick)="getOrderOnChange($event)" />

        <span class="link">All</span>
      </label>
    </div>
    <div class="orders-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcel()">Export excel</a>
      </div>
    </div>
  </header>
  <p-table
    #dt
    responsiveLayout="scroll"
    [value]="invoiceReviewList"
    styleClass="p-datatable-customers ordersListing search-more"
    [rowHover]="true"
    [rows]="50"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
    [paginator]="true"
    [rows]="defaultTake"
    [lazy]="true"
    (onLazyLoad)="getAllInvoiceReviewListingData($event)"
    [totalRecords]="totalRecords"
    sortMode="multiple"
    [globalFilterFields]="[]">
    <ng-template pTemplate="header">
      <tr>
        <th
          style="width: 3rem"
          class="number"
          pSortableColumn="invoiceReviewNumber">
          IP #
          <p-sortIcon field="invoiceReviewNumber"></p-sortIcon>
        </th>
        <th class="status" pSortableColumn="date">
          Date<p-sortIcon field="date"></p-sortIcon>
        </th>
        <th class="name" pSortableColumn="customerName">
          Customer<p-sortIcon field="customerName"></p-sortIcon>
        </th>
        <th class="jname" pSortableColumn="customerNumber">
          Cust # <p-sortIcon field="customerNumber"></p-sortIcon>
        </th>
        <th class="buyer" pSortableColumn="orderNumber">
          Order # <p-sortIcon field="orderNumber"></p-sortIcon>
        </th>
        <th class="inhanddate">Cust PO</th>
        <th class="date-time">IP Status</th>
        <th class="subtotal">Billing Comment</th>
        <th class="commission">PB</th>
        <th class="gp">Net Comm</th>
        <th class="gp">Net GP %</th>
        <th class="currency">Total Sell</th>
        <th class="cust-po">Freight total</th>
        <th class="bconsultant">Total Tax</th>
        <th class="bconsultant">Invoice Total</th>
        <th class="bconsultant">Credits/Payments</th>
        <th class="bconsultant">Total Due</th>
      </tr>
      <tr>
        <th>
          <div class="d-flex">
            <p-columnFilter
              type="text"
              field="invoiceReviewNumber"
              (input)="onFilterInput($event)"
              [showMenu]="false"></p-columnFilter>
          </div>
        </th>
        <th>
          <div class="d-flex">
            <p-columnFilter
              type="text"
              field="date"
              (input)="onFilterInput($event)"
              [showMenu]="false"></p-columnFilter>
          </div>
        </th>
        <th>
          <div class="d-flex">
            <p-columnFilter
              type="text"
              field="customerName"
              (input)="onFilterInput($event)"
              [showMenu]="false"></p-columnFilter>
          </div>
        </th>
        <th>
          <div class="d-flex">
            <p-columnFilter
              type="text"
              field="customerNumber"
              (input)="onFilterInput($event)"
              [showMenu]="false"></p-columnFilter>
          </div>
        </th>
        <th>
          <div class="d-flex">
            <p-columnFilter
              type="text"
              field="orderNumber"
              (input)="onFilterInput($event)"
              [showMenu]="false"></p-columnFilter>
          </div>
        </th>
        <th></th>
        <th>
          <div class="d-flex">
            <p-columnFilter
              type="text"
              field="ReviewStatus"
              (input)="onFilterInput($event)"
              [showMenu]="false"></p-columnFilter>
          </div>
        </th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoiceReviewList let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pSelectableRow]="invoiceReviewList"
        [pSelectableRowIndex]="rowIndex">
        <td
          class="number"
          (click)="
            openInvoice(
              invoiceReviewList?.invoiceReviewNumber,
              invoiceReviewList?.orderNumber
            )
          ">
          <a class="link"> {{ invoiceReviewList?.invoiceReviewNumber }}</a>
        </td>
        <td class="status">
          <span *ngIf="invoiceReviewList?.date | hidedynamicsdate">
            {{ invoiceReviewList?.date | date: "MM-dd-yyyy" }}
          </span>
        </td>
        <td
          class="name"
          (click)="redirectToClientSummary(invoiceReviewList?.customerNumber)">
          <a class="link">{{ invoiceReviewList?.customerName }}</a>
        </td>
        <td
          class="jname"
          class="name"
          (click)="redirectToClientSummary(invoiceReviewList?.customerNumber)">
          <a class="link">{{ invoiceReviewList?.customerNumber }}</a>
        </td>
        <td
          class="buyer"
          (click)="redirectToSummary(invoiceReviewList?.orderNumber)">
          <a class="link">{{ invoiceReviewList?.orderNumber }}</a>
        </td>
        <td class="inhandate">
          {{ invoiceReviewList?.customerPONumber }}
        </td>
        <td class="date-time">
          <a
            class="link"
            (click)="onStatusClick(invoiceReviewList?.orderNumber)"
            *ngIf="
              invoiceReviewList?.ReviewStatus?.toLowerCase() === 'invoiced'
            ">
            {{ invoiceReviewList.ReviewStatus }}
          </a>
          <span
            *ngIf="
              !(invoiceReviewList?.ReviewStatus?.toLowerCase() === 'invoiced')
            "
            >{{ invoiceReviewList.ReviewStatus }}</span
          >
        </td>
        <!-- <td
          [ngClass]="{
            'highlight-comment':
              invoiceReviewList?.commentDate > invoiceReviewList?.lastViewDate
          }"
          style="max-width: 200px"
          class="subtotal"
          (mouseenter)="
            onHoverBillingComments(
              invoiceReviewList?.invoiceReviewNumber,
              invoiceReviewList?.billingComment
            )
          "
        >
          <div class="has-dropdown d-flex align-items-center">
            <a
              [title]="invoiceReviewList?.billingComment"
              class="link"
              style="
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              {{ invoiceReviewList?.billingComment }}
            </a>
            <jni-invoice-Review-billing-comment
              *ngIf="orderNotesGridListing.length > 0"
              [orderNotesGridListing]="orderNotesGridListing"
              [orderNumber]="invoiceReviewList?.orderNumber"
              [orderBillingHeading]="'Billing Comments'"
              class="ratings-box overall ms-2"
              (scrollHiddenStatus)="addScollHiddenClass()"
              (orderNotesDisplayModalEvent)="
                orderNotesDisplayModalFunction($event)
              "
            >
            </jni-invoice-Review-billing-comment>
          </div>
        </td> -->
        <td
          [title]="invoiceReviewList?.billingComment"
          class="commission"
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 200px;
          ">
          {{ invoiceReviewList?.billingComment }}
        </td>
        <td class="commission">
          {{ invoiceReviewList?.isPreBill }}
        </td>
        <td class="gp text-right">
          {{
            invoiceReviewList?.netCommission
              | currency: "USD" : "symbol" : "1.2-2"
          }}
        </td>
        <td class="gp text-right">
          {{ invoiceReviewList?.netGPPercentage | number: "1.2-2" }}
        </td>
        <td class="currency text-right">
          {{
            invoiceReviewList?.totalSell | currency: "USD" : "symbol" : "1.2-2"
          }}
        </td>

        <td class="cust-po text-right">
          {{
            invoiceReviewList?.freightTotal
              | currency: "USD" : "symbol" : "1.2-2"
          }}
        </td>
        <td class="bconsultant text-right">
          {{
            invoiceReviewList?.totalTax | currency: "USD" : "symbol" : "1.2-2"
          }}
        </td>
        <td class="bconsultant text-right">
          {{
            invoiceReviewList?.invoiceTotal
              | currency: "USD" : "symbol" : "1.2-2"
          }}
        </td>
        <td class="bconsultant text-right">
          {{
            invoiceReviewList?.credits | currency: "USD" : "symbol" : "1.2-2"
          }}
        </td>
        <td class="bconsultant text-right">
          {{
            invoiceReviewList?.totalDue | currency: "USD" : "symbol" : "1.2-2"
          }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No invoice Review found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<jni-modal-stacker
  *ngIf="invoiceReviewSummaryDisplayModal"
  [displayModal]="invoiceReviewSummaryDisplayModal"
  (closeEvent)="closeModalForInvoiceReview()">
  <h1 class="panelHeading d-flex">
    Invoice Review Summary
    <!-- <button
    type="button"
    class="betabtn ms-2"
  >
    Beta
  </button> -->
  </h1>
  <div class="panelBody">
    <jni-invoice-review-summary
      [saleOrderId]="saleOrderId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeModalEvent)="
        closeModalForInvoiceReview()
      "></jni-invoice-review-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="orderNotesDisplayModal"
  [displayModal]="orderNotesDisplayModal"
  (closeEvent)="closeModalForOrderNotes()">
  <h1 class="panelHeading">Billing Notes</h1>
  <div class="panelBody">
    <jni-invoice-review-order-notes
      [orderNotesGridListing]="orderNotesGridListing"
      (scrollHiddenStatus)="
        addScollHiddenClass()
      "></jni-invoice-review-order-notes>
  </div>
</jni-modal-stacker>
<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeClientModal()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="customerId"
      (closeEvent)="closeClientModal()"
      [isModal]="true">
    </jni-client-details>
  </div>
</jni-modal-stacker>
<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderIdModal"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-invoice-pdf-dialogue
  [displayModal]="invoicePdfDialogue"
  *ngIf="invoiceList?.length"
  (closeDialogEvent)="closeUrlDialog()"
  [invoiceList]="invoiceList"></jni-invoice-pdf-dialogue>
